import { useEffect, useState } from 'react';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { Flex } from '@revenuemarket/cds';
import { colorTokens } from '@revenuemarket/design';
import { Checkbox, Form, Modal, ModalProps, Typography } from 'antd';

import { IStoreInfo } from '~apis/tax-invoice';

import { ManualAdd } from './ClientInfo';

interface Props extends ModalProps {
  title: string;
  disableFields?: string[];
  data: Partial<IStoreInfo>;
  onFinished?: (data: Partial<IStoreInfo>, checked: boolean) => void;
}

const EditResultFormModal: React.FC<Props> = ({ title, disableFields, data, ...props }) => {
  const [checked, setChecked] = useState(true);
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const [submittable, setSubmittable] = useState(false);

  useEffect(() => {
    form.validateFields({ validateOnly: true }).then(
      () => {
        setSubmittable(true);
      },
      () => {
        setSubmittable(false);
      },
    );
  }, [values]);

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        contractorManualInfo: data,
      });
    }
  }, [data]);

  return (
    <Modal
      open={props.open}
      onCancel={() => {
        // @ts-ignore
        props?.onCancel?.();
        form.resetFields();
      }}
      title={`${title} 정보 수정`}
      okText="수정하기"
      okButtonProps={{
        disabled:
          values?.contractorManualInfo?.corpCeo?.length === 0 ||
          !values?.contractorManualInfo?.corpAddress ||
          values?.contractorManualInfo?.members?.some((member: any) => {
            return !member?.name;
          }) ||
          !submittable,
      }}
      onOk={() => {
        props?.onFinished?.(values?.contractorManualInfo, checked);
        form.resetFields();
      }}
      width="60vw"
    >
      <Form
        layout="vertical"
        form={form}
        style={{
          marginBottom: 16,
        }}
      >
        <ManualAdd form={form} disableFields={disableFields} showReferenceEmail={false} />
      </Form>
      <Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)}>
        <Flex align="center" gap={4}>
          <Typography.Text>
            이 내용을 {title.includes('공급자') ? '회사' : '거래처'} 정보에도 반영할게요
          </Typography.Text>
          <QuestionCircleOutlined
            width={16}
            style={{
              color: colorTokens.iconDefault,
            }}
          />
        </Flex>
      </Checkbox>
    </Modal>
  );
};

export default EditResultFormModal;
